import styles from './delayInfo.module.css';

interface DelayInfoProps {
    infoText: string | null;
}

const DelayInfo = (props: DelayInfoProps) => {
    return <div className={styles.container}>{props.infoText}</div>;
};

export default DelayInfo;
